export default __webpack_public_path__ + "static/media/1v1_silver_header.ff97cdf3.png";